import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '../../component/drawer/Drawer';
import DrawerList from '../../component/drawer/DrawerList';
import { AcaoArquivo } from 'shared/constantes/acaoArquivo';
import { setDrawerType, closeDrawer } from './actions';

export default function DrawerAbrirPDF() {

    const dispatch = useDispatch();

    const open = useSelector((state) => state.drawerPDF.open);
    const callback = useSelector((state) => state.drawerPDF.callback);
    
    const drawerOptions = [
        {   "faIcon": "fa fa-file-pdf", 
            "title": 'Abrir', 
            "onClick": () => { dispatch(setDrawerType(AcaoArquivo.ABRIR)); callback(); }
        },
        {   "faIcon": "fa fa-share-alt", 
            "title": 'Compartilhar', 
            "onClick": () => { dispatch(setDrawerType(AcaoArquivo.COMPARTILHAR)); callback(); }
        },
        {   "faIcon": "fa fa-download", 
            "title": 'Salvar', 
            "onClick": () => { dispatch(setDrawerType(AcaoArquivo.DOWNLOAD)); callback(); }
        }
    ];

    return (
        <Drawer title={"Selecione uma opção"} isOpen={open} closeDrawer={() => dispatch(closeDrawer())}>
            <DrawerList options={drawerOptions} />
        </Drawer>
    );
}
